import { ReactNode } from "react";

interface CaminhoProps {
  children: ReactNode,
}

export function Caminho( { children } : CaminhoProps ) {
  return (
    <div className="flex flex-row items-center gap-2">
      {children}
    </div>
  );
}